//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { SystemEmailTemplateUpdateItem } from './SystemEmailTemplateUpdateItem';

export class CustomEmailTemplateUpdateItem extends SystemEmailTemplateUpdateItem {
    Title?: string | null;

    constructor(initializer?: Partial<CustomEmailTemplateUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomEmailTemplateUpdateItem";
}
